export default "__VITE_ASSET__CkJWfolZ__"